import { NgModule } from '@angular/core';
import { FoundationAutoSelectOnTabDirective } from './auto-select-on-tab.directive';
import { FoundationAutoSelectionEnforcedDirective } from './auto-selection-enforced.directive';

@NgModule({
    declarations: [ FoundationAutoSelectOnTabDirective, FoundationAutoSelectionEnforcedDirective ],
    exports: [ FoundationAutoSelectOnTabDirective, FoundationAutoSelectionEnforcedDirective ]
})
export class FoundationAutocompleteDirectivesModule {}
